import {
  Component,
  ElementRef,
  inject,
  TemplateRef,
  ViewChild,
} from "@angular/core";

import { SchoolFeedbackService } from "./school-feedback.service";

import { HttpClient } from "@angular/common/http";

import * as SchoolApiRoutes from "src/app/GlobalVariable";

import { ActivatedRoute, Router } from "@angular/router";

import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

import {
  SchoolFeedbackDeleteRequestDTO,
  SchoolFeedbackDTO,
  SchoolFeedbackUpdateRequestDTO,
} from "./school-feedback.interface";

import { FormGroup, FormControl, Validators } from "@angular/forms";

import { UserLoginService } from "src/app/login/userlogin.service";

import {
  UserAffiliationMappingDTO,
  UserAffiliationMappingReadByUserIdRequestDTO,
  UserAffiliationMappingReadUserBySchoolIdRequestDTO,
} from "../../SchoolUserMapping/user-affiliation-mapping.interface";

import { UserAffiliationMappingService } from "../../SchoolUserMapping/user-affiliation-mapping.service";

import { ConfirmmodalserviceService } from "src/app/Shared Utilities/confirm-delete-modal/confirmdeletemodal.service";

import { FeeComponentMasterDeleteRequestDTO } from "../../BackOffice/fee-component-master/fee-component-master.interface";

import { FeedbackMasterDeleteRequestDTO } from "src/app/hospital/interface & services/feedbackMaster/feedbackMaster.interface";

import { ToastrService } from "ngx-toastr";

import { SchoolRoutingUtilityService } from "src/app/School/school-routing-utility.service";

type FeedbackTeacherGridRow = {
  id: number;

  fullName: string;

  designation: string;

  mobileNo: string;

  emailId: string;
};

@Component({
  selector: "app-feedback-tab",

  templateUrl: "./feedback-tab.component.html",

  styleUrls: ["./feedback-tab.component.css"],
})
export class FeedbackTabComponent {
  schoolRoutingUtility = inject(SchoolRoutingUtilityService);

  toastr = inject(ToastrService);

  loadingFeedbacks = false;

  selectedTeacherId!: number;

  isParent = false;

  isSchoolAdmin = false;

  router = inject(Router);

  schoolUserMappingService = inject(UserAffiliationMappingService);

  isLoading = false;

  confirmModal = inject(ConfirmmodalserviceService);

  activeMenuIndex: number | null = null;

  userData: UserAffiliationMappingDTO[] = [];

  SchoolUserMappingService = inject(UserAffiliationMappingService);

  User = inject(UserLoginService).User();

  teacherList: { id: number; fullName: string }[] = []; // Additional view-only grid; existing teacher dropdown is unchanged.

  teacherGridList: FeedbackTeacherGridRow[] = [];

  isTeacherGridLoading = false;

  teacherGridError = "";

  private teacherGridRequestSerial = 0;

  @ViewChild("teacherFeedbackDetailsTemplate", { static: false })
  teacherFeedbackDetailsTemplate!: TemplateRef<any>;

  selectedFeedbackTeacher: FeedbackTeacherGridRow | null = null;

  selectedTeacherModalFeedbacks: SchoolFeedbackDTO[] = [];

  isTeacherFeedbackModalLoading = false;

  teacherFeedbackModalError = "";

  teacherFeedbackModalAverage = 0;

  private teacherFeedbackModalRequestSerial = 0;

  private teacherFeedbackDetailsModalRef: NgbModalRef | null = null;

  studentList: { id: number; name: string }[] = [];

  isSubmitting: boolean = false;

  @ViewChild("feedbackTemplate", { static: false })
  feedbackTemplate!: ElementRef;

  addFeedbackTemplate!: NgbModalRef;

  isEditMode = false;

  private feedbackService = inject(SchoolFeedbackService);

  private modalService = inject(NgbModal);

  private route = inject(ActivatedRoute);

  userRole: string = "";

  affiliationType = "";

  schoolId!: number;

  teacherId?: number;

  allFeedbacks: SchoolFeedbackDTO[] = [];

  teacherFeedbacks: SchoolFeedbackDTO[] = [];

  overallRating: number = 0;

  excellentPercentage: number = 0;

  goodPercentage: number = 0;

  avgPercentage: number = 0;

  poorPercentage: number = 0;

  totalReviews: number = 0;

  weights: any = {
    best: 5,

    better: 4,

    good: 3,

    fair: 2,

    poor: 1,
  };

  rating = 0;

  feedbackForm = new FormGroup({
    feedbackId: new FormControl(0),

    masterId: new FormControl(0, [Validators.required]),

    masterType: new FormControl(""),

    teacherId: new FormControl(0, [Validators.required, Validators.min(1)]),

    schoolId: new FormControl(0),

    experienceLevel: new FormControl("", [Validators.required]),

    rating: new FormControl(0, [
      Validators.required,

      Validators.min(0),

      Validators.max(5),
    ]),

    feedback: new FormControl(""),

    feedbackType: new FormControl(""),

    status: new FormControl(""),

    otherDetail1: new FormControl(""),

    otherDetail2: new FormControl(""),

    otherDetail3: new FormControl(""),

    otherDetail4: new FormControl(""),

    otherDetail5: new FormControl(""),

    otherDetail6: new FormControl(""),

    isActive: new FormControl(1),

    actionUser: new FormControl(""),
  });

  ngOnInit() {
    let userId = this.User.userId;

    if (userId) {
      this.getUserMapping(userId);
    }

    const params = this.route.snapshot.paramMap;
  }

  getUserMapping(userId: number): void {
    if (!userId) return;

    const data: UserAffiliationMappingReadByUserIdRequestDTO = { userId };

    this.SchoolUserMappingService.UserAffiliationMapping_ReadByUserId(
      data,
    ).subscribe({
      next: (res: any) => {
        const mappingItems: UserAffiliationMappingDTO[] = Array.isArray(res)
          ? res
          : Array.isArray(res?.items)
            ? res.items
            : Array.isArray(res?.Items)
              ? res.Items
              : Array.isArray(res?.item)
                ? res.item
                : [];

        this.userData = mappingItems;

        const routeSchoolId = Number(
          this.route.snapshot.paramMap.get("schoolid") ||
            this.route.snapshot.paramMap.get("schoolId") ||
            this.route.snapshot.queryParamMap.get("schoolid") ||
            this.route.snapshot.queryParamMap.get("schoolId") ||
            0,
        );

        const loginSchoolId = Number(
          (this.User as any)?.schoolId || (this.User as any)?.moduleId || 0,
        );

        const activeMappings = mappingItems.filter((mapping: any) => {
          const isActive = Number(mapping?.isActive ?? mapping?.IsActive ?? 1);

          const isDeleted = Number(
            mapping?.isDeleted ?? mapping?.IsDeleted ?? 0,
          );

          return isActive === 1 && isDeleted !== 1;
        });

        const mappingsToUse = activeMappings.length
          ? activeMappings
          : mappingItems;

        let mappingForSchool: any = null;

        if (routeSchoolId > 0) {
          mappingForSchool = mappingsToUse.find(
            (mapping: any) =>
              Number(mapping?.schoolId ?? mapping?.SchoolId ?? 0) ===
              routeSchoolId,
          );
        }

        if (!mappingForSchool && loginSchoolId > 0) {
          mappingForSchool = mappingsToUse.find(
            (mapping: any) =>
              Number(mapping?.schoolId ?? mapping?.SchoolId ?? 0) ===
              loginSchoolId,
          );
        }

        if (!mappingForSchool) {
          mappingForSchool = mappingsToUse.find(
            (mapping: any) =>
              Number(mapping?.schoolId ?? mapping?.SchoolId ?? 0) > 0,
          );
        }

        this.schoolId = Number(
          routeSchoolId ||
            loginSchoolId ||
            mappingForSchool?.schoolId ||
            mappingForSchool?.SchoolId ||
            0,
        ); // Display the registered school name for the school resolved above.
        // Never use a different affiliation's school name on this page.

        this.feedbackCenterSchoolName = "";

        const selectedSchoolMapping = mappingsToUse.find(
          (mapping: any) =>
            Number(mapping?.schoolId ?? mapping?.SchoolId ?? 0) ===
            Number(this.schoolId),
        );

        if (selectedSchoolMapping) {
          this.feedbackCenterApplySchoolName(
            selectedSchoolMapping,

            Number(this.schoolId),
          );
        }

        if (
          !this.feedbackCenterSchoolName &&
          Number(
            (this.User as any)?.schoolId ?? (this.User as any)?.moduleId ?? 0,
          ) === Number(this.schoolId)
        ) {
          this.feedbackCenterApplySchoolName(this.User, Number(this.schoolId));
        }

        this.feedbackCenterLoadRegisteredSchoolName();

        if (!this.schoolId || this.schoolId <= 0) {
          this.teacherList = [];

          this.teacherFeedbacks = [];

          this.loadingFeedbacks = false;

          this.toastr.warning("School information is not available.");

          return;
        }

        const rawAffiliationType = String(
          mappingForSchool?.affiliationType ??
            mappingForSchool?.AffiliationType ??
            (this.User as any)?.affiliationType ??
            (this.User as any)?.designation ??
            "",
        )
          .trim()

          .toLowerCase();

        this.affiliationType = rawAffiliationType;

        this.isParent = rawAffiliationType.includes("parent");

        this.isSchoolAdmin =
          rawAffiliationType.includes("school admin") ||
          rawAffiliationType.includes("school owner") ||
          rawAffiliationType.includes("school-owner") ||
          rawAffiliationType === "owner" ||
          rawAffiliationType === "admin";

        if (this.isSchoolAdmin) {
          this.loadSchoolFeedbackDashboard();
        }

        this.loadTeachersBySchool(this.schoolId);
      },

      error: (err: any) => {
        console.error("Failed to load user-school mapping:", err);

        this.userData = [];

        this.teacherList = [];

        this.teacherGridList = [];

        this.teacherFeedbacks = [];

        this.loadingFeedbacks = false;
      },
    });
  }

  handleChangeExperienceLevel(event: Event) {
    const select = event.target as HTMLSelectElement;

    const value = select.value;

    if (value) {
      const newRating = this.weights[value]; // Update rating field

      this.feedbackForm.patchValue({
        rating: newRating,
      });
    }
  }

  loadTeacherFeedback(teacherId: number): void {
    if (!teacherId || Number(teacherId) <= 0) {
      this.teacherFeedbacks = [];

      this.calculatePercentages();

      this.loadingFeedbacks = false;

      return;
    }

    this.loadingFeedbacks = true;

    this.teacherFeedbacks = [];

    this.feedbackService

      .SchoolFeedback_ReadByTeacherId({ teacherId: Number(teacherId) })

      .subscribe({
        next: (res: any) => {
          const feedbackItems: SchoolFeedbackDTO[] = Array.isArray(res)
            ? res
            : Array.isArray(res?.items)
              ? res.items
              : Array.isArray(res?.Items)
                ? res.Items
                : Array.isArray(res?.item)
                  ? res.item
                  : Array.isArray(res?.data)
                    ? res.data
                    : [];

          this.teacherFeedbacks = feedbackItems.filter((feedback: any) => {
            const isDeleted = Number(
              feedback?.isDeleted ?? feedback?.IsDeleted ?? 0,
            );

            const isActive = Number(
              feedback?.isActive ?? feedback?.IsActive ?? 1,
            );

            return isDeleted !== 1 && isActive !== 0;
          });

          this.calculatePercentages();

          this.loadingFeedbacks = false;
        },

        error: (err: any) => {
          console.error("Failed to load teacher feedback:", err);

          this.teacherFeedbacks = [];

          this.calculatePercentages();

          this.loadingFeedbacks = false;
        },
      });
  }

  closeModal(): void {
    this.addFeedbackTemplate.close();
  }

  openFeedbackForm() {
    if (!this.teacherList.length) {
      this.toastr.warning("No teacher is available to give feedback.");

      return;
    }

    this.feedbackForm.reset();

    this.feedbackForm.get("teacherId")?.enable();

    this.addFeedbackTemplate = this.modalService.open(this.feedbackTemplate, {
      size: "md",

      backdrop: "static",
    });

    const patchData = {
      masterId: this.User.userId,

      schoolId: this.schoolId,

      masterType: this.affiliationType,

      teacherId: 0,

      actionUser: this.User.userId.toString(),
    };

    this.feedbackForm.patchValue(patchData);
  }

  submitFeedback(): void {
    this.feedbackForm.markAllAsTouched();

    if (this.feedbackForm.valid) {
      this.isSubmitting = true;

      const formData = this.feedbackForm.getRawValue();

      const data = {
        feedbackId: formData.feedbackId ?? 0,

        masterId: formData.masterId ?? 0,

        masterType: formData.masterType ?? "",

        schoolId: formData.schoolId ?? 0,

        teacherId: formData.teacherId ?? 0,

        rating: formData.rating ?? 0,

        feedback: formData.feedback ?? "",

        feedbackType: formData.feedbackType ?? "",

        status: formData.status ?? "",

        otherDetail1: formData.otherDetail1 ?? "",

        otherDetail2: formData.otherDetail2 ?? "",

        otherDetail3: formData.otherDetail3 ?? "",

        otherDetail4: formData.otherDetail4 ?? "",

        otherDetail5: formData.otherDetail5 ?? "",

        otherDetail6: formData.otherDetail6 ?? "",

        isActive: formData.isActive ?? 1,

        actionUser: this.User.userId.toString(),
      };

      if (data.feedbackId && data.feedbackId > 0) {
        this.feedbackService.SchoolFeedback_Update(data).subscribe({
          next: (res) => {
            this.closeModal();

            this.isSubmitting = false;

            this.loadTeacherFeedback(
              Number(res?.teacherId || this.selectedTeacherId),
            );
          },

          error: (err) => {
            this.isSubmitting = false;
          },
        });
      } else {
        this.feedbackService.SchoolFeedback_Create(data).subscribe({
          next: (res) => {
            this.closeModal();

            this.isSubmitting = false;

            this.selectedTeacherId = Number(res?.teacherId || data.teacherId);

            this.loadTeacherFeedback(this.selectedTeacherId);
          },

          error: (err) => {
            this.isSubmitting = false;
          },
        });
      }
    }
  }

  handleActionClick(event: { actionName: string; rowData: SchoolFeedbackDTO }) {
    const formData = event.rowData;

    if (event.actionName === "Delete") {
      this.confirmModal

        .openDeleteModal("Feedback", formData)

        .subscribe((res) => {
          if (res) {
            let data: SchoolFeedbackDeleteRequestDTO = {
              feedbackId: formData.feedbackId,

              actionUser: this.User.userId.toString(),
            };

            this.deleteFeedback(data);
          }
        });
    }

    if (event.actionName === "Edit") {
      const data: SchoolFeedbackUpdateRequestDTO = {
        ...formData,

        feedbackId: formData.feedbackId,

        otherDetail1: formData.otherDetail1 || "",

        otherDetail2: formData.otherDetail2 || "",

        otherDetail3: formData.otherDetail3 || "",

        otherDetail4: formData.otherDetail4 || "",

        otherDetail5: formData.otherDetail5 || "",

        otherDetail6: formData.otherDetail6 || "",

        actionUser: this.User.userId.toString(),

        isActive: 1,
      };

      this.openEditModal(data);
    }
  }

  private mapRatingToLevel(rate: number): string {
    if (rate === 5) return "best";

    if (rate === 4) return "better";

    if (rate === 3) return "good";

    if (rate === 2) return "average";

    return "poor";
  }

  openEditModal(data: SchoolFeedbackUpdateRequestDTO) {
    this.feedbackForm.reset();

    this.feedbackForm.patchValue({
      feedbackId: data.feedbackId,

      masterId: data.masterId,

      masterType: data.masterType,

      teacherId: data.teacherId,

      schoolId: data.schoolId,

      rating: data.rating,

      experienceLevel: this.mapRatingToLevel(data.rating),

      feedback: data.feedback,

      feedbackType: data.feedbackType,

      status: data.status,

      otherDetail1: data.otherDetail1,

      otherDetail2: data.otherDetail2,

      otherDetail3: data.otherDetail3,

      otherDetail4: data.otherDetail4,

      otherDetail5: data.otherDetail5,

      otherDetail6: data.otherDetail6,

      isActive: data.isActive,

      actionUser: this.User.userId.toString(),
    });

    this.feedbackForm.get("teacherId")?.disable();

    this.addFeedbackTemplate = this.modalService.open(this.feedbackTemplate, {
      size: "md",

      backdrop: "static",
    });
  }

  deleteFeedback(data: FeedbackMasterDeleteRequestDTO): void {
    this.isLoading = true;

    this.activeMenuIndex = null;

    this.feedbackService.SchoolFeedback_Delete(data).subscribe({
      next: () => {
        this.loadTeacherFeedback(this.teacherId!);

        this.isLoading = false;
      },

      error: (err) => {
        this.isLoading = false;
      },
    });
  }

  loadTeachersBySchool(schoolId: number): void {
    // Load every page so the grid contains all teachers, including those with no feedback.

    const requestSerial = ++this.teacherGridRequestSerial;

    this.teacherGridList = [];

    this.teacherGridError = "";

    if (!schoolId || Number(schoolId) <= 0) {
      this.teacherList = [];

      this.teacherFeedbacks = [];

      this.loadingFeedbacks = false;

      this.isTeacherGridLoading = false;

      return;
    }

    this.isTeacherGridLoading = true;

    const pageSize = 500;

    const teachers = new Map<number, FeedbackTeacherGridRow>();

    const finishLoading = (): void => {
      if (requestSerial !== this.teacherGridRequestSerial) return;

      this.isTeacherGridLoading = false;

      this.teacherGridList = Array.from(teachers.values());

      this.teacherList = this.teacherGridList.map((teacher) => ({
        id: teacher.id,

        fullName: teacher.fullName,
      }));

      if (this.teacherList.length === 0) {
        this.teacherId = undefined;

        this.teacherFeedbacks = [];

        this.calculatePercentages();

        this.loadingFeedbacks = false;

        return;
      }

      const teacherToLoad =
        this.selectedTeacherId &&
        this.teacherList.some(
          (teacher) => Number(teacher.id) === Number(this.selectedTeacherId),
        )
          ? Number(this.selectedTeacherId)
          : Number(this.teacherList[0].id);

      this.teacherId = teacherToLoad;

      this.selectedTeacherId = teacherToLoad;

      this.loadTeacherFeedback(teacherToLoad);
    };

    const loadPage = (pageNo: number): void => {
      const payload: UserAffiliationMappingReadUserBySchoolIdRequestDTO = {
        schoolId: Number(schoolId),

        affiliationType: "Teaching Staff",

        pageSize,

        pageNo,

        whereClause: "",

        orderByClause: "",
      };

      this.schoolUserMappingService

        .UserAffiliationMapping_ReadUserBySchoolId(payload)

        .subscribe({
          next: (res: any) => {
            if (requestSerial !== this.teacherGridRequestSerial) return;

            const teacherItems: any[] = Array.isArray(res)
              ? res
              : Array.isArray(res?.items)
                ? res.items
                : Array.isArray(res?.Items)
                  ? res.Items
                  : Array.isArray(res?.item)
                    ? res.item
                    : Array.isArray(res?.data?.items)
                      ? res.data.items
                      : []; // The mapping API can also supply the school's registered name.

            if (!this.feedbackCenterSchoolName) {
              this.feedbackCenterApplySchoolName(res, Number(schoolId));

              for (const teacherItem of teacherItems) {
                if (this.feedbackCenterSchoolName) break;

                this.feedbackCenterApplySchoolName(
                  teacherItem,

                  Number(schoolId),
                );
              }
            }

            const previousCount = teachers.size;

            teacherItems.forEach((item: any) => {
              const id = Number(
                item?.userId ?? item?.UserId ?? item?.id ?? item?.Id ?? 0,
              );

              const isActive = Number(item?.isActive ?? item?.IsActive ?? 1);

              const isDeleted = Number(item?.isDeleted ?? item?.IsDeleted ?? 0);

              const itemSchoolId = Number(
                item?.schoolId ?? item?.SchoolId ?? schoolId,
              );

              if (
                id <= 0 ||
                isActive === 0 ||
                isDeleted === 1 ||
                itemSchoolId !== Number(schoolId)
              )
                return;

              const fullName =
                [
                  item?.firstName ?? item?.FirstName,

                  item?.middleName ?? item?.MiddleName,

                  item?.lastName ?? item?.LastName,
                ]

                  .filter(Boolean)

                  .join(" ")

                  .trim() ||
                String(
                  item?.fullName ??
                    item?.FullName ??
                    item?.userName ??
                    item?.UserName ??
                    "",
                ).trim() ||
                `Teacher #${id}`;

              teachers.set(id, {
                id,

                fullName,

                designation: String(
                  item?.designation ??
                    item?.Designation ??
                    item?.staffDesignation ??
                    item?.StaffDesignation ??
                    "",
                ).trim(),

                mobileNo: String(
                  item?.mobileNo ??
                    item?.MobileNo ??
                    item?.mobileNumber ??
                    item?.MobileNumber ??
                    item?.phoneNumber ??
                    item?.PhoneNumber ??
                    "",
                ).trim(),

                emailId: String(
                  item?.emailId ??
                    item?.EmailId ??
                    item?.email ??
                    item?.Email ??
                    item?.emailAddress ??
                    item?.EmailAddress ??
                    "",
                ).trim(),
              });
            }); // Stop when the final page is reached or the API repeats the same page.

            if (
              teacherItems.length === pageSize &&
              teachers.size > previousCount &&
              pageNo < 100
            ) {
              loadPage(pageNo + 1);

              return;
            }

            if (teacherItems.length === pageSize && pageNo === 100) {
              this.teacherGridError =
                "The teacher list reached the maximum number of pages.";
            }

            finishLoading();
          },

          error: (err: any) => {
            if (requestSerial !== this.teacherGridRequestSerial) return;

            console.error("Failed to load teaching staff:", err);

            this.teacherGridError =
              teachers.size > 0
                ? "Some teachers could not be loaded. Please refresh the page."
                : "Unable to load the teacher list.";

            finishLoading();
          },
        });
    };

    loadPage(1);
  } // Teacher-wise feedback viewer is read-only and does not change the existing dropdown.

  viewAllTeacherFeedback(teacher: FeedbackTeacherGridRow): void {
    if (!teacher || !teacher.id) return;

    if (this.teacherFeedbackDetailsModalRef) {
      this.teacherFeedbackDetailsModalRef.dismiss();
    }

    const requestSerial = ++this.teacherFeedbackModalRequestSerial;

    this.selectedFeedbackTeacher = teacher;

    this.selectedTeacherModalFeedbacks = [];

    this.teacherFeedbackModalAverage = 0;

    this.teacherFeedbackModalError = "";

    this.isTeacherFeedbackModalLoading = true;

    const modalRef = this.modalService.open(
      this.teacherFeedbackDetailsTemplate,

      {
        size: "xl",

        centered: true,

        scrollable: true,
      },
    );

    this.teacherFeedbackDetailsModalRef = modalRef;

    const onModalClosed = () => {
      if (this.teacherFeedbackDetailsModalRef === modalRef) {
        this.teacherFeedbackDetailsModalRef = null;

        ++this.teacherFeedbackModalRequestSerial;
      }
    };

    modalRef.result.then(onModalClosed, onModalClosed);

    this.feedbackService

      .SchoolFeedback_ReadByTeacherId({ teacherId: Number(teacher.id) })

      .subscribe({
        next: (res: any) => {
          if (requestSerial !== this.teacherFeedbackModalRequestSerial) return;

          const feedbackItems: SchoolFeedbackDTO[] = Array.isArray(res)
            ? res
            : Array.isArray(res?.items)
              ? res.items
              : Array.isArray(res?.Items)
                ? res.Items
                : Array.isArray(res?.item)
                  ? res.item
                  : Array.isArray(res?.data)
                    ? res.data
                    : Array.isArray(res?.data?.items)
                      ? res.data.items
                      : [];

          this.selectedTeacherModalFeedbacks = feedbackItems.filter(
            (feedback: any) =>
              Number(
                feedback?.teacherId ?? feedback?.TeacherId ?? teacher.id,
              ) === Number(teacher.id) &&
              Number(feedback?.isDeleted ?? feedback?.IsDeleted ?? 0) !== 1 &&
              Number(feedback?.isActive ?? feedback?.IsActive ?? 1) !== 0,
          );

          const total = this.selectedTeacherModalFeedbacks.length;

          this.teacherFeedbackModalAverage = total
            ? Number(
                (
                  this.selectedTeacherModalFeedbacks.reduce(
                    (sum, feedback) => sum + Number(feedback.rating || 0),

                    0,
                  ) / total
                ).toFixed(1),
              )
            : 0;

          this.isTeacherFeedbackModalLoading = false;
        },

        error: (err: any) => {
          if (requestSerial !== this.teacherFeedbackModalRequestSerial) return;

          console.error("Failed to load selected teacher feedback:", err);

          this.selectedTeacherModalFeedbacks = [];

          this.teacherFeedbackModalError =
            "Unable to load feedback for this teacher. Please try again.";

          this.isTeacherFeedbackModalLoading = false;
        },
      });
  }

  onTeacherChange(
    selectedTeacher: { id: number; fullName: string } | undefined,
  ) {
    const selectedTeacherId = selectedTeacher ? selectedTeacher.id : undefined; // Make sure it's a number

    const id = selectedTeacherId;

    this.feedbackForm.patchValue({ teacherId: id });

    this.teacherId = selectedTeacherId;

    if (selectedTeacherId !== undefined) {
      this.loadTeacherFeedback(selectedTeacherId);
    } else {
      this.teacherFeedbacks = [];
    }
  }

  goBackToSchool(): void {
    this.router.navigate(
      ["/" + this.schoolRoutingUtility.masterPathName + "/spe-school-detail"],

      {
        queryParams: { tab: "class" },
      },
    );
  }

  calculatePercentages() {
    if (!this.teacherFeedbacks || this.teacherFeedbacks.length === 0) {
      this.excellentPercentage = 0;

      this.goodPercentage = 0;

      this.avgPercentage = 0;

      this.poorPercentage = 0;

      this.overallRating = 0;

      return;
    }

    const total = this.teacherFeedbacks.length;

    this.totalReviews = total;

    const excellent = this.teacherFeedbacks.filter(
      (f) => f.rating === 5,
    ).length;

    const good = this.teacherFeedbacks.filter((f) => f.rating === 4).length;

    const average = this.teacherFeedbacks.filter((f) => f.rating === 3).length;

    const poor = this.teacherFeedbacks.filter((f) => f.rating <= 2).length;

    this.excellentPercentage = Number(((excellent / total) * 100).toFixed(1));

    this.goodPercentage = Number(((good / total) * 100).toFixed(1));

    this.avgPercentage = Number(((average / total) * 100).toFixed(1));

    this.poorPercentage = Number(((poor / total) * 100).toFixed(1)); // ⭐ Overall Rating (1 decimal place)

    this.overallRating = Number(
      (
        this.teacherFeedbacks.reduce((sum, f) => sum + f.rating, 0) / total
      ).toFixed(1),
    );
  }

  scrollLeft(containerId: string) {
    const container = document.getElementById(containerId);

    if (container) {
      container.scrollBy({ left: -300, behavior: "smooth" });
    }
  }

  scrollRight(containerId: string) {
    const container = document.getElementById(containerId);

    if (container) {
      container.scrollBy({ left: 300, behavior: "smooth" });
    }
  } // Nishwik Teacher Feedback Center — additions; existing legacy actions remain untouched.

  showClassicFeedback = false;

  feedbackCenterTab: "overview" | "teachers" | "inbox" | "followups" =
    "overview";

  selectedFeedbackProfile: FeedbackTeacherGridRow | null = null;

  feedbackCenterQuery = "";

  feedbackCenterYear = "all";

  feedbackCenterPeriod = "all";

  feedbackCenterStatus = "all";

  feedbackCenterRating = "all";

  feedbackCenterTeacherId = "all";

  feedbackCenterPage = 1;

  readonly feedbackCenterPageSize = 8;

  feedbackCenterSchoolName = "";

  feedbackCenterSchoolNameLoading = false;

  private feedbackCenterSchoolNameRequestSerial = 0;

  private feedbackCenterSchoolHttp = inject(HttpClient);

  schoolFeedbackRecords: SchoolFeedbackDTO[] = [];

  schoolFeedbackLoading = false;

  schoolFeedbackError = "";

  schoolFeedbackPartial = false;

  schoolFeedbackRecordsCount = 0;

  private schoolFeedbackRequestSerial = 0;

  viewedFeedbackRecord: SchoolFeedbackDTO | null = null;

  @ViewChild("feedbackCenterDetailsModal", { static: false })
  feedbackCenterDetailsModal!: TemplateRef<any>;

  @ViewChild("feedbackCenterPrivacyModal", { static: false })
  feedbackCenterPrivacyModal!: TemplateRef<any>;

  private feedbackCenterApplySchoolName(
    source: any,

    expectedSchoolId: number,
  ): void {
    if (!source || !expectedSchoolId) return;

    const candidates = [
      source,

      source?.school,

      source?.School,

      source?.schoolMaster,

      source?.SchoolMaster,

      source?.schoolDetails,

      source?.SchoolDetails,

      source?.item,

      source?.Item,

      source?.data,

      source?.Data,

      source?.result,

      source?.Result,

      source?.items?.[0],

      source?.Items?.[0],
    ];

    for (const candidate of candidates) {
      if (
        !candidate ||
        typeof candidate !== "object" ||
        Array.isArray(candidate)
      )
        continue;

      const candidateSchoolId = Number(
        candidate.schoolId ??
          candidate.SchoolId ??
          candidate.schoolID ??
          candidate.SchoolID ??
          0,
      );

      if (candidateSchoolId > 0 && candidateSchoolId !== expectedSchoolId)
        continue;

      const registeredName = [
        candidate.schoolName,

        candidate.SchoolName,

        candidate.schoolDisplayName,

        candidate.SchoolDisplayName,

        candidate.schoolFullName,

        candidate.SchoolFullName,

        candidate.institutionName,

        candidate.InstitutionName,

        candidate.schoolTitle,

        candidate.SchoolTitle,

        candidate.school?.name,

        candidate.school?.schoolName,

        candidate.School?.Name,

        candidate.School?.SchoolName,

        candidate.schoolMaster?.name,

        candidate.SchoolMaster?.Name,
      ].find((value) => typeof value === "string" && value.trim().length > 0);

      if (registeredName) {
        const displayName = registeredName.trim();

        if (!/^School\s*#?\s*\d+$/i.test(displayName)) {
          this.feedbackCenterSchoolName = displayName;

          return;
        }
      }
    }
  }

  private feedbackCenterLoadRegisteredSchoolName(): void {
    const schoolId = Number(this.schoolId || 0);

    const requestSerial = ++this.feedbackCenterSchoolNameRequestSerial;

    if (!schoolId) return; // Use the existing SchoolMaster route when GlobalVariable exports it.
    // Do not invent a URL or change any existing feedback API endpoint.

    const schoolMasterReadById = (SchoolApiRoutes as any).SchoolMaster_ReadById;

    if (
      typeof schoolMasterReadById !== "string" ||
      !schoolMasterReadById.trim()
    )
      return;

    this.feedbackCenterSchoolNameLoading = true;

    this.feedbackCenterSchoolHttp

      .post<any>(schoolMasterReadById, { schoolId })

      .subscribe({
        next: (res: any) => {
          if (
            requestSerial !== this.feedbackCenterSchoolNameRequestSerial ||
            schoolId !== Number(this.schoolId)
          )
            return;

          this.feedbackCenterApplySchoolName(res, schoolId);

          this.feedbackCenterSchoolNameLoading = false;
        },

        error: (err: any) => {
          if (requestSerial !== this.feedbackCenterSchoolNameRequestSerial)
            return;

          console.error("Unable to load registered school name:", err);

          this.feedbackCenterSchoolNameLoading = false;
        },
      });
  }

  loadSchoolFeedbackDashboard(): void {
    if (!this.isSchoolAdmin || !Number(this.schoolId)) return;

    const request = ++this.schoolFeedbackRequestSerial;

    this.schoolFeedbackLoading = true;

    this.schoolFeedbackError = "";

    this.schoolFeedbackPartial = false;

    this.schoolFeedbackRecords = []; // Uses the existing Nishwik API — NO mock/demo records.

    this.feedbackService

      .SchoolFeedback_ReadBySchoolId({ schoolId: Number(this.schoolId) } as any)

      .subscribe({
        next: (res: any) => {
          if (request !== this.schoolFeedbackRequestSerial) return;

          const records: SchoolFeedbackDTO[] =
            this.extractFeedbackCenterItems(res);

          if (!this.feedbackCenterSchoolName) {
            this.feedbackCenterApplySchoolName(res, Number(this.schoolId));

            if (records.length > 0)
              this.feedbackCenterApplySchoolName(
                records[0],

                Number(this.schoolId),
              );
          }

          this.schoolFeedbackRecords = records.filter(
            (r: any) =>
              Number(r?.isDeleted ?? r?.IsDeleted ?? 0) !== 1 &&
              Number(r?.isActive ?? r?.IsActive ?? 1) !== 0 &&
              Number(r?.schoolId ?? r?.SchoolId ?? this.schoolId) ===
                Number(this.schoolId),
          );

          const reported = Number(
            res?.totalRecords ??
              res?.TotalRecords ??
              res?.totalCount ??
              res?.data?.totalRecords ??
              res?.data?.totalCount ??
              this.schoolFeedbackRecords.length,
          );

          this.schoolFeedbackRecordsCount = Number.isFinite(reported)
            ? reported
            : this.schoolFeedbackRecords.length;

          this.schoolFeedbackPartial =
            this.schoolFeedbackRecordsCount > this.schoolFeedbackRecords.length;

          this.schoolFeedbackLoading = false;
        },

        error: (err: any) => {
          if (request !== this.schoolFeedbackRequestSerial) return;

          console.error("Failed to load school feedback:", err);

          this.schoolFeedbackError =
            "School-wide feedback could not be loaded. Please check FB/ReadBySchoolId and access permissions.";

          this.schoolFeedbackLoading = false;
        },
      });
  }

  private extractFeedbackCenterItems(res: any): SchoolFeedbackDTO[] {
    if (Array.isArray(res)) return res;

    for (const candidate of [
      res?.items,

      res?.Items,

      res?.item,

      res?.data?.items,

      res?.data?.Items,

      res?.data,

      res?.result?.items,
    ]) {
      if (Array.isArray(candidate)) return candidate;
    }

    return [];
  }

  get feedbackCenterYearOptions(): string[] {
    return Array.from(
      new Set(
        this.schoolFeedbackRecords

          .map((f) => this.feedbackCenterAcademicYear((f as any)?.createdOn))

          .filter((year) => year !== "Unknown"),
      ),
    )

      .sort()

      .reverse();
  }

  feedbackCenterAcademicYear(value: any): string {
    const d = new Date(value);

    if (Number.isNaN(d.getTime())) return "Unknown";

    const begin = d.getMonth() >= 3 ? d.getFullYear() : d.getFullYear() - 1;

    return `${begin}-${String((begin + 1) % 100).padStart(2, "0")}`;
  }

  private feedbackCenterInScope(r: SchoolFeedbackDTO): boolean {
    const d = new Date((r as any)?.createdOn);

    if (
      this.feedbackCenterYear !== "all" &&
      this.feedbackCenterAcademicYear(d) !== this.feedbackCenterYear
    )
      return false;

    if (this.feedbackCenterPeriod !== "all") {
      if (Number.isNaN(d.getTime())) return false;

      const days = Number(this.feedbackCenterPeriod);

      if (
        d.getTime() < Date.now() - days * 86400000 ||
        d.getTime() > Date.now()
      )
        return false;
    }

    return true;
  }

  get feedbackCenterScopeRecords(): SchoolFeedbackDTO[] {
    return this.schoolFeedbackRecords.filter((r) =>
      this.feedbackCenterInScope(r),
    );
  }

  get feedbackCenterDisplayRecords(): SchoolFeedbackDTO[] {
    const q = this.feedbackCenterQuery.trim().toLowerCase();

    return this.feedbackCenterScopeRecords

      .filter((r) => {
        if (
          this.feedbackCenterStatus !== "all" &&
          this.feedbackCenterStatusLabel(r) !== this.feedbackCenterStatus
        )
          return false;

        if (
          this.feedbackCenterRating !== "all" &&
          Number(r.rating) !== Number(this.feedbackCenterRating)
        )
          return false;

        if (
          this.feedbackCenterTeacherId !== "all" &&
          Number(r.teacherId) !== Number(this.feedbackCenterTeacherId)
        )
          return false;

        if (!q) return true;

        return [
          this.feedbackCenterTeacherName(Number(r.teacherId)),

          this.feedbackCenterCategory(r),

          this.isFeedbackCenterRestricted(r) ? "" : String(r.feedback || ""),
        ].some((s) => s.toLowerCase().includes(q));
      })

      .sort(
        (a, b) =>
          new Date((b as any).createdOn).getTime() -
          new Date((a as any).createdOn).getTime(),
      );
  }

  get feedbackCenterStatusOptions(): string[] {
    return Array.from(
      new Set(
        this.feedbackCenterScopeRecords.map((r) =>
          this.feedbackCenterStatusLabel(r),
        ),
      ),
    ).sort();
  }

  feedbackCenterStatusLabel(r: SchoolFeedbackDTO): string {
    const value = String((r as any)?.status ?? (r as any)?.Status ?? "").trim();

    return value || "Not classified";
  }

  feedbackCenterStatusClass(r: SchoolFeedbackDTO): string {
    const status = this.feedbackCenterStatusLabel(r).toLowerCase();

    if (this.isFeedbackCenterRestricted(r)) return "nfc-restricted";

    if (["closed", "resolved"].includes(status)) return "nfc-closed";

    if (["under review", "pending review"].includes(status))
      return "nfc-review";

    if (
      ["follow-up assigned", "needs clarification", "in progress"].includes(
        status,
      )
    )
      return "nfc-assigned";

    return "nfc-new";
  }

  isFeedbackCenterRestricted(r: SchoolFeedbackDTO): boolean {
    const raw: any = r;

    return (
      raw?.isRestricted === true ||
      raw?.restricted === true ||
      String(raw?.status ?? "")
        .toLowerCase()

        .includes("restricted") ||
      String(raw?.feedbackType ?? "")
        .toLowerCase()

        .includes("sensitive")
    );
  }

  feedbackCenterCategory(r: SchoolFeedbackDTO): string {
    return String((r as any)?.feedbackType ?? "").trim() || "Not categorized";
  }

  feedbackCenterTeacherName(teacherId: number): string {
    return (
      this.teacherGridList.find((t) => Number(t.id) === Number(teacherId))
        ?.fullName || `Teacher #${teacherId}`
    );
  }

  feedbackCenterTeacherDetails(
    teacherId: number,
  ): FeedbackTeacherGridRow | undefined {
    return this.teacherGridList.find((t) => Number(t.id) === Number(teacherId));
  }

  feedbackCenterInitials(name: string): string {
    return (
      (name || "?")

        .trim()

        .split(/\s+/)

        .slice(0, 2)

        .map((s) => s.charAt(0).toUpperCase())

        .join("") || "?"
    );
  }

  feedbackCenterIsAttention(r: SchoolFeedbackDTO): boolean {
    return [
      "new",

      "pending",

      "under review",

      "pending review",

      "needs clarification",

      "follow-up assigned",

      "restricted escalation",

      "in progress",
    ].includes(this.feedbackCenterStatusLabel(r).toLowerCase());
  }

  feedbackCenterIsFollowup(r: SchoolFeedbackDTO): boolean {
    return [
      "needs clarification",

      "follow-up assigned",

      "restricted escalation",

      "in progress",

      "resolved",
    ].includes(this.feedbackCenterStatusLabel(r).toLowerCase());
  }

  get feedbackCenterAttentionRecords(): SchoolFeedbackDTO[] {
    return this.feedbackCenterDisplayRecords.filter((r) =>
      this.feedbackCenterIsAttention(r),
    );
  }

  get feedbackCenterFollowupRecords(): SchoolFeedbackDTO[] {
    return this.feedbackCenterDisplayRecords.filter((r) =>
      this.feedbackCenterIsFollowup(r),
    );
  }

  get feedbackCenterAwaitingRecords(): SchoolFeedbackDTO[] {
    return this.feedbackCenterScopeRecords.filter((r) =>
      ["new", "pending"].includes(
        this.feedbackCenterStatusLabel(r).toLowerCase(),
      ),
    );
  }

  get feedbackCenterTeachersWithReviews(): number {
    const schoolTeacherIds = new Set(
      this.teacherGridList.map((t) => Number(t.id)),
    );

    return new Set(
      this.feedbackCenterScopeRecords

        .map((r) => Number(r.teacherId))

        .filter((id) => schoolTeacherIds.has(id)),
    ).size;
  }

  feedbackCenterOrdinary(records: SchoolFeedbackDTO[]): SchoolFeedbackDTO[] {
    return records.filter(
      (r) =>
        !this.isFeedbackCenterRestricted(r) &&
        Number.isFinite(Number(r.rating)) &&
        Number(r.rating) >= 1 &&
        Number(r.rating) <= 5,
    );
  }

  feedbackCenterAverage(records: SchoolFeedbackDTO[]): number | null {
    const valid = this.feedbackCenterOrdinary(records);

    return valid.length
      ? Number(
          (
            valid.reduce((s, r) => s + Number(r.rating), 0) / valid.length
          ).toFixed(1),
        )
      : null;
  }

  feedbackCenterRatingCount(
    records: SchoolFeedbackDTO[],

    rating: number,
  ): number {
    return this.feedbackCenterOrdinary(records).filter(
      (r) => Number(r.rating) === rating,
    ).length;
  }

  feedbackCenterRatingPercent(
    records: SchoolFeedbackDTO[],

    rating: number,
  ): number {
    const valid = this.feedbackCenterOrdinary(records);

    return valid.length
      ? Number(
          (
            (this.feedbackCenterRatingCount(records, rating) / valid.length) *
            100
          ).toFixed(1),
        )
      : 0;
  }

  feedbackCenterTeacherRecords(teacherId: number): SchoolFeedbackDTO[] {
    return this.feedbackCenterScopeRecords.filter(
      (r) => Number(r.teacherId) === Number(teacherId),
    );
  }

  feedbackCenterOpenCount(teacherId: number): number {
    return this.feedbackCenterTeacherRecords(teacherId).filter((r) =>
      this.feedbackCenterIsAttention(r),
    ).length;
  }

  get feedbackCenterVisibleTeachers(): FeedbackTeacherGridRow[] {
    const q = this.feedbackCenterQuery.trim().toLowerCase();

    return this.teacherGridList.filter(
      (t) =>
        !q ||
        t.fullName.toLowerCase().includes(q) ||
        t.designation.toLowerCase().includes(q) ||
        this.feedbackCenterTeacherRecords(t.id).some(
          (r) =>
            !this.isFeedbackCenterRestricted(r) &&
            String(r.feedback || "")
              .toLowerCase()

              .includes(q),
        ),
    );
  }

  get feedbackCenterInboxPageItems(): SchoolFeedbackDTO[] {
    return this.feedbackCenterDisplayRecords.slice(
      (this.feedbackCenterPage - 1) * this.feedbackCenterPageSize,

      this.feedbackCenterPage * this.feedbackCenterPageSize,
    );
  }

  get feedbackCenterTotalPages(): number {
    return Math.max(
      1,

      Math.ceil(
        this.feedbackCenterDisplayRecords.length / this.feedbackCenterPageSize,
      ),
    );
  }

  feedbackCenterChangeTab(
    tab: "overview" | "teachers" | "inbox" | "followups",
  ): void {
    this.feedbackCenterTab = tab;

    this.selectedFeedbackProfile = null;

    this.feedbackCenterPage = 1;
  }

  feedbackCenterOpenTeacher(teacher: FeedbackTeacherGridRow): void {
    this.selectedFeedbackProfile = teacher;

    this.feedbackCenterTab = "teachers";
  }

  feedbackCenterChangeFilters(): void {
    this.feedbackCenterPage = 1;
  }

  feedbackCenterResetFilters(): void {
    this.feedbackCenterQuery = "";

    this.feedbackCenterYear = "all";

    this.feedbackCenterPeriod = "all";

    this.feedbackCenterStatus = "all";

    this.feedbackCenterRating = "all";

    this.feedbackCenterTeacherId = "all";

    this.feedbackCenterPage = 1;
  }

  feedbackCenterOpenRecord(record: SchoolFeedbackDTO): void {
    if (!this.isSchoolAdmin) return;

    this.viewedFeedbackRecord = record;

    this.modalService.open(this.feedbackCenterDetailsModal, {
      centered: true,

      size: "lg",
    });
  }

  feedbackCenterOpenPrivacy(): void {
    this.modalService.open(this.feedbackCenterPrivacyModal, {
      centered: true,

      size: "lg",
    });
  }

  feedbackCenterExport(): void {
    if (
      !this.isSchoolAdmin ||
      this.schoolFeedbackLoading ||
      this.schoolFeedbackError ||
      this.schoolFeedbackPartial
    ) {
      this.toastr.warning(
        "Complete authorized feedback data is required before exporting.",
      );

      return;
    }

    const safe = (value: unknown): string => {
      let str = String(value ?? "");

      if (/^\s*[=+@\t\r-]/.test(str)) str = "'" + str;

      return '"' + str.replace(/"/g, '""') + '"';
    };

    const rows = this.feedbackCenterDisplayRecords

      .filter((r) => !this.isFeedbackCenterRestricted(r))

      .map((r) => [
        r.feedbackId,

        this.feedbackCenterTeacherName(Number(r.teacherId)),

        (r as any).createdOn ?? "",

        this.feedbackCenterCategory(r),

        r.rating,

        this.feedbackCenterStatusLabel(r),
      ]);

    if (!rows.length) {
      this.toastr.info("No eligible feedback is available for export.");

      return;
    }

    const csv = [
      [
        "Feedback ID",

        "Teacher",

        "Submitted On",

        "Category",

        "Rating",

        "Status",
      ],

      ...rows,
    ]

      .map((row) => row.map(safe).join(","))

      .join("\r\n");

    const blob = new Blob(["\ufeff" + csv], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;

    link.download =
      "Nishwik_Teacher_Feedback_" +
      new Date().toISOString().slice(0, 10) +
      ".csv";

    document.body.appendChild(link);

    link.click();

    link.remove();

    URL.revokeObjectURL(url);
  }
}
